export default "__VITE_ASSET__5990fbb6__"